import { Component, Input, OnInit } from '@angular/core';
import { CompetitionStore } from '../../../../common-page-components/stores/entities-store/competition-store';
import { IEvents } from '../../../../common-page-components/stores/entities-store/events-store';

@Component({
  selector: 'app-event-info-panel',
  templateUrl: './event-info-panel.component.html',
  styleUrls: ['./event-info-panel.component.scss']
})
export class EventInfoPanelComponent implements OnInit {
  @Input() competition_store:CompetitionStore;
  constructor() { }

  ngOnInit() {
  }

  hasOptions(competition:IEvents){
    return competition.Options.filter(value => ['WRE', 'PWRE', 'WADA'].findIndex(status=> status === value) > -1).length > 0
  }

}
